import { ErrorHandler, Inject, Injectable } from '@angular/core';

import { Channel, Socket } from 'phoenix';
import { Observable } from 'rxjs';

import { WebsocketService } from '@recruitee/websocket';

import { WS_URL } from '../tokens';
import {
  AdminChannel,
  CandidatePageChannel,
  ChannelName,
  CompanyChannel,
  JobsChannel,
  MailboxPageChannel,
  NotesChannel,
  NotesChannelName,
  NotificationsChannel,
  OfferPipelineChannel,
  RequisitionChannel,
  OfferChannel,
  TextingThreadChannel,
} from './channel.types';

@Injectable({ providedIn: 'root' })
export class AdminSocket extends WebsocketService {
  public adminId: number;
  public companyId: number;

  constructor(@Inject(WS_URL) private wsUrl: string, errorHandler: ErrorHandler) {
    super(errorHandler);
  }

  public connect(
    admin: { id: number; socketToken: string; authenticationToken: string },
    company_id: number,
  ): Socket {
    let socketParams: object;
    this.adminId = admin.id;
    this.companyId = company_id;

    if (admin.socketToken) {
      socketParams = {
        socket_token: admin.socketToken,
        admin_id: admin.id,
        company_id,
      };
    } else {
      socketParams = { auth_token: admin.authenticationToken, company_id };
    }

    return this.socketConnect(this.wsUrl, { params: socketParams });
  }

  public updateParams(params: {
    socket_token?: string;
    auth_token?: string;
    admin_id?: number;
    company_id: number;
  }): void {
    super.updateParams(params);
  }

  public subscribeToChannel<T extends `jobs:${number}-${number}`>(
    topic: T,
  ): Observable<JobsChannel>;
  public subscribeToChannel<T extends `mailbox-page:${number}`>(
    topic: T,
  ): Observable<MailboxPageChannel>;
  public subscribeToChannel<T extends `admin:${number}:${number}`>(
    topic: T,
  ): Observable<AdminChannel>;
  public subscribeToChannel<T extends `offer-pipeline:${number}`>(
    topic: T,
  ): Observable<OfferPipelineChannel>;
  public subscribeToChannel<T extends NotesChannelName>(topic: T): Observable<NotesChannel>;
  public subscribeToChannel<T extends `notifications:${number}`>(
    topic: T,
  ): Observable<NotificationsChannel>;
  public subscribeToChannel<T extends `candidate-page:${number}`>(
    topic: T,
  ): Observable<CandidatePageChannel>;
  public subscribeToChannel<T extends `company:${number}`>(topic: T): Observable<CompanyChannel>;
  public subscribeToChannel<T extends `requisition:${number}`>(
    topic: T,
  ): Observable<RequisitionChannel>;
  public subscribeToChannel<T extends `offer:${number}`>(topic: T): Observable<OfferChannel>;

  public subscribeToChannel<T extends `texting-thread:${number}`>(
    topic: T,
  ): Observable<TextingThreadChannel>;
  public subscribeToChannel(topic: ChannelName): Observable<Channel> {
    return super.subscribeToChannel(topic);
  }
}
